import { render } from "./Step8Component.vue?vue&type=template&id=4426fd12"
import script from "./Step8Component.vue?vue&type=script&lang=js"
export * from "./Step8Component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__